/**
 * @generated SignedSource<<299c26970c3186f19ddb9b9bcd91907b>>
 * @relayHash f7bba14ed0ba3e90a97cbe6770906a31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f678bd76c790e4ebfae99dd7eda54817e5a91318514b0cfd2d4a03ccfb0c7ad

import type { ConcreteRequest } from 'relay-runtime';
export type useForgeAppQuery_appByIdQuery$variables = {
  appAri: string;
  contextIds: ReadonlyArray<string>;
};
export type useForgeAppQuery_appByIdQuery$data = {
  readonly app: {
    readonly installationsByContexts: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly appEnvironmentVersion: {
            readonly extensions: {
              readonly nodes: ReadonlyArray<{
                readonly extensionData: AGG$JSON;
              } | null | undefined> | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly privacyPolicy: string | null | undefined;
    readonly termsOfService: string | null | undefined;
  };
};
export type useForgeAppQuery_appByIdQuery = {
  response: useForgeAppQuery_appByIdQuery$data;
  variables: useForgeAppQuery_appByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contextIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "privacyPolicy"
},
v4 = {
  "kind": "ScalarField",
  "name": "termsOfService"
},
v5 = [
  {
    "kind": "Variable",
    "name": "contextIds",
    "variableName": "contextIds"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "extensionData"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useForgeAppQuery_appByIdQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "App",
          "kind": "LinkedField",
          "name": "app",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "args": (v5/*: any*/),
              "concreteType": "AppInstallationByIndexConnection",
              "kind": "LinkedField",
              "name": "installationsByContexts",
              "plural": false,
              "selections": [
                {
                  "concreteType": "AppInstallationByIndexEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "AppInstallation",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "AppEnvironmentVersion",
                          "kind": "LinkedField",
                          "name": "appEnvironmentVersion",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "AppVersionExtensions",
                              "kind": "LinkedField",
                              "name": "extensions",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "AppVersionExtension",
                                  "kind": "LinkedField",
                                  "name": "nodes",
                                  "plural": true,
                                  "selections": [
                                    (v6/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "app"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useForgeAppQuery_appByIdQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "app",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": (v5/*: any*/),
            "concreteType": "AppInstallationByIndexConnection",
            "kind": "LinkedField",
            "name": "installationsByContexts",
            "plural": false,
            "selections": [
              {
                "concreteType": "AppInstallationByIndexEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AppInstallation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AppEnvironmentVersion",
                        "kind": "LinkedField",
                        "name": "appEnvironmentVersion",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AppVersionExtensions",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AppVersionExtension",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v7/*: any*/)
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "3f678bd76c790e4ebfae99dd7eda54817e5a91318514b0cfd2d4a03ccfb0c7ad",
    "metadata": {},
    "name": "useForgeAppQuery_appByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8343441a33776d30a7ee1f511ffa878d";

export default node;
